import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'

import {SelectMemberWrapper} from '../pages/member/SelectMemberWrapper'
import {CreateMemberWrapper} from '../pages/member/CreateMemberWrapper'
import {DeviceWrapper} from '../pages/device/DeviceWrapper'
import {CreateDeviceWrapper} from '../pages/device/CreateDeviceWrapper'
import {CreateTagWrapper} from '../pages/tag/CreateTagWrapper'
import {TagWrapper} from '../pages/tag/TagWrapper'
import {TagHistoryWrapper} from '../pages/tag/TagHistoryWrapper'
import {SwitchAccountPage} from '../pages/member/SwitchAccount'
import {CodeWrapper} from '../pages/code/CodeWrapper'
import {CodeGeneratorWrapper} from '../pages/code/CodeGeneratorWrapper'
import {TagDetailWrapper} from '../pages/tag/TagDetailWrapper'
import {EditTagWrapper} from '../pages/tag/EditTagWrapper'
import {CodePreviewWrapper} from '../pages/code/CodePreviewWrapper'
import {MemberProfileWrapper} from '../pages/member-profile/MemberProfileWrapper'
import {MemberProfileEditWrapper} from '../pages/member-profile/MemberProfileEditWrapper'
import AccountSetting from '../pages/account/AccountSetting'
import EditCodeWrapper from '../pages/code/codeEditForm/EditCodeWrapper'

import {CodeDetail} from '../pages/code/CodeDetail'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}

        <Route path='auth/*' element={<Navigate to='/select-member' />} />

        <Route path='select-member' element={<SelectMemberWrapper />} />
        <Route path='switch-account' element={<SwitchAccountPage />} />
        <Route path='setting' element={<AccountSetting />} />
        <Route path='create-member' element={<CreateMemberWrapper />} />
        <Route path='device' element={<DeviceWrapper />} />
        <Route path='create-device' element={<CreateDeviceWrapper />} />
        <Route path='create-tag' element={<CreateTagWrapper />} />
        <Route path='device/:deviceId/tag/:tagId' element={<TagWrapper />} />
        <Route path='device/:deviceId/tag/:tagId/history' element={<TagHistoryWrapper />} />
        <Route path='device/:deviceId/tag/:tagId/detail' element={<TagDetailWrapper />} />
        <Route path='device/:deviceId/tag/:tagId/edit' element={<EditTagWrapper />} />
        <Route path='code' element={<CodeWrapper />} />
        <Route path='code/:codeId' element={<CodeDetail />} />
        <Route path='code-edit/:codeId' element={<EditCodeWrapper />} />
        <Route path='create-qr-code' element={<CodeGeneratorWrapper />} />
        <Route path='code-preview' element={<CodePreviewWrapper />} />
        <Route path='member-profile' element={<MemberProfileWrapper />} />
        <Route path='member-profile/edit' element={<MemberProfileEditWrapper />} />

        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='builder' element={<BuilderPageWrapper />} />
        <Route path='menu-test' element={<MenuTestPage />} />

        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
